// extracted by mini-css-extract-plugin
module.exports = {"modalPrompt":"Prompt_modalPrompt__18bne"};